export default __webpack_public_path__ + "static/media/up-black.16521a3a.svg";